import { render, staticRenderFns } from "./BackToLogin.vue?vue&type=template&id=f31c24d0&scoped=true&lang=pug&"
import script from "./BackToLogin.vue?vue&type=script&lang=ts&"
export * from "./BackToLogin.vue?vue&type=script&lang=ts&"
import style0 from "./BackToLogin.vue?vue&type=style&index=0&id=f31c24d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31c24d0",
  null
  
)

export default component.exports